<template>
  <UIAlert type="error" class="app-disruption-message">
    Allposit is currently experiencing service disruptions due to an ongoing <a href="https://health.aws.amazon.com/health/status" target="_blank">AWS outage</a>.
  </UIAlert>
</template>

<script setup lang="ts">
import { UIAlert } from '@ui/core'
</script>

<style>
.app-disruption-message {
  @apply !justify-center;
  @apply !bg-red-500;
  @apply !text-white;

  a {
    @apply underline underline-offset-2;
    @apply decoration-red-200;
    @apply hover:no-underline;
  }
}
</style>
